import { render, staticRenderFns } from "./storeIntrInfo.vue?vue&type=template&id=cdbeadfe&scoped=true"
import script from "./storeIntrInfo.vue?vue&type=script&lang=js"
export * from "./storeIntrInfo.vue?vue&type=script&lang=js"
import style0 from "./storeIntrInfo.vue?vue&type=style&index=0&id=cdbeadfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbeadfe",
  null
  
)

export default component.exports